import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Helmet } from 'react-helmet-async';
import { MapleLeaf } from '@/components/common/MapleLeaf';
import Header from '@/components/layout/Header';
import MainLayout from '@/components/layout/MainLayout';

const Privacy = () => {
  const features = [
    "You get the same world-class AI models as everyone else",
    "Create and manage AI agents with full control over critical tasks",
    "Your knowledge and documents never leave your device",
    "Compute stays in Canada, protected by Canadian law",
    "We don't train models with your chats, they actually get deleted when you delete them",
    "Work, study, and create with confidence",
  ];

  return (
    <MainLayout>
      <Helmet>
        <title>Privacy - mapleos</title>
        <meta
          name="description"
          content="mapleos: a privacy-first digital canvas, committed to data privacy and Canadian law."
        />
      </Helmet>
      <div className="bg-background text-foreground">
        <Header />
        <main className="container mx-auto px-4 py-12 md:py-24">
          <section className="flex flex-col md:flex-row items-center justify-between gap-12 mb-20">
            <div className="md:w-1/2">
              <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
                All the power of leading AI without leaving Canada
              </h1>
              <p className="text-lg mb-4">
                For professionals who need to protect client trust, for Canadians who treat privacy as identity, and for
                students who want every advantage without the risk — this is your AI.
              </p>
              <p className="text-lg mb-6">
                AI should make your life easier, not put your licence at risk, not betray your values, not drain your
                wallet in U.S. dollars.
              </p>
              <p className="text-xl font-semibold text-primary mb-6">mapleos is Canada's sovereign AI platform.</p>
              <p className="text-lg">
                Built on Canadian infrastructure, compliant with Canadian law, and priced fairly for Canadians. The
                moment you use it, the compromise ends.
              </p>
            </div>
            <div className="md:w-1/2 flex justify-center">
              <img
                src="/images/privacy/capebreton.jpg"
                alt="Canadian AI Infrastructure"
                className="rounded-lg shadow-xl max-w-full h-auto"
              />
            </div>
          </section>

          <Separator className="my-16 bg-primary/20" />

          <section className="mb-20">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">Why Choose mapleos for Privacy?</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {features.map((feature, index) => (
                <Card
                  key={index}
                  className="bg-card border-primary/30 shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <CardContent className="p-6 flex items-start space-x-4">
                    <MapleLeaf className="text-primary flex-shrink-0 mt-1" size={24} />
                    <p className="text-lg font-medium">{feature}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </section>

          <Separator className="my-16 bg-primary/20" />

          <section className="text-center">
            <p className="text-2xl font-semibold text-muted-foreground">Canada's sovereign AI platform for everyday use</p>
          </section>
        </main>
      </div>
    </MainLayout>
  );
};

export default Privacy;